import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const getInstallationProcessListUseCase = async (
  signal: AbortSignal,
) => {
  try {
    const state = store.getState();

    const namespace = state?.yourSlice?.authContext?.customerNamespace;
    const source_id = state.yourSlice.connectionView?.source?.source_id;

    const response = await apiUseCases.getInstallationProcessList(
      namespace,
      source_id,
      signal,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch installation processes")
        .message,
    };
  }
};
